import { useHead } from '@vueuse/head'
import { computed } from 'vue'

import { useBlogsPageStore } from '@/stores/blogsComponents'
export const fetchSingleBlogStore = async (slug: string) => {
  const marketsStore = useBlogsPageStore()

  await marketsStore.fetchBlogsBySlug(slug)
}
export const fetchLatestBlogStore = async (category: string) => {
  const marketsStore = useBlogsPageStore()

  await marketsStore.fetchLatestBlogs(category)
}
export const useBlogData = () => {
  const marketsStore = useBlogsPageStore()
  return computed(() => marketsStore.getBlogData)
}
export const useSigleBlock = () => {
  const marketsStore = useBlogsPageStore()
  return computed(() => marketsStore.getBlogsPageData)
}

export const useBlogsSeo = () => {
  useHead({
    title: useBlogsSeoTitle(),
    meta: [
      {
        name: 'description',
        content: useBlogsSeoDescription()
      },
      {
        property: 'og:title',
        content: useBlogsSeoTitle()
      },
      {
        property: 'og:description',
        content: useBlogsSeoDescription()
      }
    ]
  })
}

export const useBlogsSeoTitle = () => {
  const marketsStore = useBlogsPageStore()
  return computed(() => {
    if (marketsStore.getBlogsPageData?.fields?.seo_blog?.title) {
      return marketsStore.getBlogsPageData?.fields?.seo_blog?.title
    }
    return 'Default Title'
  })
}

export const useBlogsSeoDescription = () => {
  const marketsStore = useBlogsPageStore()
  return computed(() => {
    if (marketsStore.getBlogsPageData?.fields?.seo_blog?.description) {
      return marketsStore.getBlogsPageData?.fields?.seo_blog?.description
    }
    return 'Default Description'
  })
}

export const useBlogsSeoIndexFollow = (): boolean => {
  const marketsStore = useBlogsPageStore()

  return marketsStore.getBlogsPageData?.fields?.seo_blog?.noindexnofollow === true
}
